export const fuseListConstants = {
  FUSE_LIST_LOADING: "FUSE_LIST_LOADING",
  FUSE_LIST_SUCCESS: "FUSE_LIST_SUCCESS",
  FUSE_LIST_FAILURE: "FUSE_LIST_FAILURE",
};
